import { Component, OnDestroy, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { navItems } from './../../_nav';
import { ChartService } from '../../services/chart.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']

})
export class DefaultLayoutComponent implements OnInit, OnDestroy {


  constructor(private service: ChartService, private router: Router, private modalService: NgbModal,
    public translate: TranslateService) {

    // Translate languages
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');

    // Get the language from cookie if it exists
    if (!this.service.checkCookie('language')) {
      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    } else {
      translate.use(this.service.getCookie('language'));
    }

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });

    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Detect where we are !
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.dashboardOn = false;
        this.settingsOn = false;
        this.notifsOn = false;
        this.historyOn = false;
        const componentName = event.url.replace('/', '');
        // console.log("Route changed to : " + componentName)
        if (componentName === 'dashboard') {
          this.dashboardOn = true;
        }
        if (componentName === 'settings') {
          this.settingsOn = true;
        }
        if (componentName === 'notifs') {
          this.notifsOn = true;
          // make the notifications of connectivity read
          this.service.makeConnectivityNotificationsRead();

        }
        if (componentName === 'history') {
          this.historyOn = true;
        }
        // tslint:disable-next-line: no-trailing-whitespace
        if (componentName === '' || (componentName !== 'dashboard') && (componentName !== 'settings')
          && (componentName !== 'notifs') && (componentName !== 'history')) {  // the first load of the app !
          this.dashboardOn = true;
        }
      }
    });
  }
  deviceId: string;
  deviceName: string;
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;

  notifications = [];
  dashboardOn = false;
  settingsOn = false;
  notifsOn = false;
  historyOn = false;

  notificationNumber = 0;
  connnectNotificationNumber = 0;
  /*============================================*/
  // DECLARATION DE FIXER UN PROBLEME
  /*=========================================== */
  @ViewChild('fixModal') public fixModal: ElementRef;
  toFixNotificationId: string;
  problemText = '';
  confirmFixButtonDisabled = false;

  toDate = ((millis: number) => {
    const d = new Date(millis);
    return d.toLocaleDateString('fr-FR') + (this.translate.currentLang === 'en' ? ' at ' : ' à ') + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  });

  ngOnInit() {

    this.service.getCurrentSetting().subscribe((setting) => {
      this.deviceName = setting.deviceName == null ? this.service.getId() : setting.deviceName;
    });

    this.deviceId = this.service.getId();

    // get the number of passing over thresholds notifications (notifications de seuils)
    this.service.getNumberNewNotifications().subscribe(nbN => {
      if (nbN == null) {
        // console.log('not existing')
        this.notificationNumber = 0;
      } else {
        // console.log('existing !')
        this.notificationNumber = nbN;
      }
    });

    // get the number of connectivity notifications (notifications de connectivité)
    this.service.getNumberNewConnectNotifications().subscribe(ncnN => {
      if (ncnN == null) {
        this.connnectNotificationNumber = 0;
      } else {
        this.connnectNotificationNumber = ncnN;
      }
    });
    // get the last 5 notifications for notification dropdown.
    this.service.getLastNNotifications(5).on('value', snapShot => {
      this.notifications = [];
      snapShot.forEach(child => {
        this.notifications.push({
          key: child.key,
          date: child.val().date,
          message: child.val().message,
          title: child.val().title,
          type: child.val().type,
          fixed: child.val().fixed == null ? '' : child.val().fixed,
        });
      });
      this.notifications.sort((n1, n2) => {
        return n2.date - n1.date;
      });
      if (this.notifications.length > 6) { // to show only the last 6 notifications
        this.notifications.splice(-1, 1);
      }
    });

  }

  // Make the notifications of connectivity read and return null to resolve the bug when clicking the notifDropdown.
  onNotifDropdownClick() {
    this.service.makeConnectivityNotificationsRead();
    return false;
  }

  deconnect() {
    this.service.signOut();
  }

  

  /** To relaod home */
  onHeaderClick(event: any) {
    const targetClass: string = event.target.className;
    if (targetClass.includes('navbar-brand')) {
      this.router.navigate(['home']).then(() => {
        window.location.reload();
      });
    }
  }

  /*============================================*/
  // Related to fix Problem
  /*=========================================== */
  fix(key) {
    this.toFixNotificationId = key;
    this.modalService.open(this.fixModal, { ariaLabelledBy: 'fix-modal-title' }).result.then(result => {
      this.problemText = '';
      this.confirmFixButtonDisabled = false;
    }, reason => {
      this.problemText = '';
      this.confirmFixButtonDisabled = false;
    });
  }
  confirmFix() {
    this.confirmFixButtonDisabled = true;
    this.service.fixNotification(this.problemText, this.toFixNotificationId).then(() => {
      this.setTemporaryFix(this.toFixNotificationId, this.problemText);
      this.service.minusNotification().then(() => {
        this.modalService.dismissAll();
      });
    });
  }

  // Display problem is fixed to user (because notif dropdown is static)
  setTemporaryFix(key, fixedText) {
    for (const n of this.notifications) {
      if (n.key === key) {
        n.fixed = fixedText === '' ? ' ' : fixedText;
      }
    }
  }
  /*============================================*/
  // Related To fix problem
  /*=========================================== */


  getCopyYear() {
    return new Date().getFullYear();
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }


}
